import React, {useEffect,useState} from 'react';

function encoded(blob) {
  return new Promise((resolve,reject)=>{
    const reader=new FileReader();
    reader.onload=()=>resolve(reader.result.split(',')[1]);reader.onerror=reject;
    reader.readAsDataURL(blob);
  });
}
export default function SmartBookingUpload({token,request,onChoose,selected,onBusy,disabled}) {
  const [files,setFiles]=useState([]),[busy,setBusy]=useState(false),[error,setError]=useState('');
  useEffect(()=>{
    let current=true;
    request('files/status',{token}).then(rows=>{if(current)setFiles(rows);}).catch(()=>{if(current)setError('Dateistand nicht verfügbar.');});
    return ()=>{current=false;};
  },[request,token]);
  async function refresh() {
    setError('');
    try {setFiles(await request('files/status',{token}));} catch(e) {setError(e.message);}
  }
  async function upload(file) {
    if(!file) return;
    if(file.size>20*1024*1024){setError('Die Datei ist größer als 20 MB.');return;}
    setError('');setBusy(true);onBusy(true);
    try {
      const {id,chunk_size:size}=await request('files/start',{token,name:file.name,size:file.size});
      for(let offset=0;offset<file.size;offset+=size) {
        const data=await encoded(file.slice(offset,offset+size));
        await request('files/'+id+'/chunks/'+Math.floor(offset/size),{token,data});
      }
      await request('files/'+id+'/finish',{token});await refresh();
    } catch(e) {setError(e.message||'Upload nicht bestätigt. Bitte eine Unterlagenfrist vereinbaren.');}
    finally {setBusy(false);onBusy(false);}
  }
  const labels={clean:'geprüft',uploading:'unvollständig',pending_scan:'Prüfung ausstehend',scanning:'wird geprüft',rejected:'abgewiesen',scan_error:'Prüfung fehlgeschlagen'};
  return <fieldset disabled={disabled||busy}><legend>Jahresabrechnung direkt bereitstellen</legend>
    <input aria-label="Jahresabrechnung hochladen" type="file" accept=".pdf,.jpg,.jpeg,.png" onChange={e=>upload(e.target.files[0])}/>
    <p>PDF, JPG oder PNG bis 20 MB. Bis zu fünf geprüfte Dateien pro Buchung.</p>
    <button type="button" onClick={refresh}>Dateistand aktualisieren</button>
    {files.map(file=><label key={file.id} className="block"><input type="checkbox" checked={selected.includes(file.id)} disabled={file.status!=='clean'||(selected.length>=5&&!selected.includes(file.id))}
      onChange={e=>onChoose(file.id,e.target.checked)}/>{file.name} · {labels[file.status]||'Status offen'}</label>)}
    {busy&&<p role="status">Datei wird übertragen …</p>}{error&&<p role="alert">{error}</p>}
  </fieldset>;
}
